import { render, staticRenderFns } from "./depositConfirm.vue?vue&type=template&id=871fdde2&scoped=true&"
import script from "./depositConfirm.vue?vue&type=script&lang=js&"
export * from "./depositConfirm.vue?vue&type=script&lang=js&"
import style0 from "./depositConfirm.vue?vue&type=style&index=0&id=871fdde2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871fdde2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('871fdde2')) {
      api.createRecord('871fdde2', component.options)
    } else {
      api.reload('871fdde2', component.options)
    }
    module.hot.accept("./depositConfirm.vue?vue&type=template&id=871fdde2&scoped=true&", function () {
      api.rerender('871fdde2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pricingDeposit/depositConfirm.vue"
export default component.exports